
const baseList = [
{
url: '/doctorList',
img: require('../../assets/clinic/banner1.png'), // 404

},
{
url: '/doctorList',
img: require('../../assets/clinic/banner2.png'),
},
{
url: '/doctorList',
img: require('../../assets/clinic/banner3.png'),
},
{
url: '/doctorList',
img: require('../../assets/clinic/banner4.png'),
}
]
const datalist=[
{
doctorname:'张代钊',
dutie:'主任医师',
headphoto:require('../../assets/doctor/zhangdaizhao.png'),
hospitalname:'中日友好医院',
skillname:"星期二上午;星期五上午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'张安君',
dutie:'主治医师',
headphoto:require('../../assets/doctor/zhanganjun.png'),
hospitalname:'北京好中医',
skillname:"每周一、周三、周四、周五下午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'王赫',
dutie:'医师',
headphoto:require('../../assets/doctor/wanghe.jpg'),
hospitalname:'北京好中医',
skillname:"每周一至周五全天",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'叶霈智',
dutie:'副主任医师',
headphoto:require('../../assets/doctor/yepeizhi.jpg'),
hospitalname:'中国医学科学院肿瘤医院',
skillname:"每周四、周六下午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'郭全',
dutie:'副主任医师',
headphoto:require('../../assets/doctor/guoquan.jpg'),
hospitalname:'中国中医科学院西苑医院',
skillname:"每周四上午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'郝迎旭',
dutie:'主任医师',
headphoto:require('../../assets/doctor/haoyingxu.jpg'),
hospitalname:'中日友好医院',
skillname:"每周六上午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'张铁权',
dutie:'坐诊医生',
headphoto:require('../../assets/doctor/zhangtiequan.jpg'),
hospitalname:'北京好中医',
skillname:"每周日全天",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'丛法滋',
dutie:'坐诊医生',
headphoto:require('../../assets/doctor/congfazi.jpg'),
hospitalname:'北京好中医',
skillname:"每周六上午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'武常生',
dutie:'坐诊医生',
headphoto:require('../../assets/doctor/wuchangsheng.jpg'),
hospitalname:'北京好中医',
skillname:"每周六下午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'武超',
dutie:'坐诊医生',
headphoto:require('../../assets/doctor/wuchao.jpg'),
hospitalname:'北京好中医',
skillname:"每周日上午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
]
const datalistCD=[
{
doctorname:'张树峰',
dutie:'坐诊医师',
headphoto:require('../../assets/doctor/zhangshufeng.jpg'),
hospitalname:'北京好中医承德医馆',
skillname:"每周二上午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'张玉田',
dutie:'坐诊医师',
headphoto:require('../../assets/doctor/zhangyutian.jpg'),
hospitalname:'北京好中医承德医馆',
skillname:"每周三全天",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'杨金梅',
dutie:'坐诊医师',
headphoto:require('../../assets/doctor/yangjinmei.jpg'),
hospitalname:'北京好中医承德医馆',
skillname:"每周三全天",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
{
doctorname:'赵丽华',
dutie:'坐诊医师',
headphoto:require('../../assets/doctor/zhaolihua.jpg'),
hospitalname:'北京好中医承德医馆',
skillname:"每周四上午",
style:"background-image:url('../../assets/doctor/wuchao.jpg')",
},
]
import common from "../../api/common";
import empty from '@/components/empty/index.vue';

import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

export default {
components: {
Swiper,
SwiperItem,
empty
},
data() {
return {
isShow:0,
cities : ["上海","北京","广州","重庆","西安"],
searchData:'',
arr : [],
searchhistory:[],//搜索历史
datalist:datalist,
sun:"",
discount:0,
kfc:"",
lock:1,
docid:'',
pay: true,
inquirypeople:this.$store.state.inquirypeople,
patientid: this.$store.state.userInfo.id,
addressTitle:[],
page:1,             //页码
pagination:1,//请求数据
heightof:"-90",
message: '暂无医生',
displayshow: false,
skillData: [],
noDataText: '',
total: 0,
skillname: '',
doctorname: '',
type: '',
demo01_index: 0,
demo01_list: baseList,
clinicType:1,
}
},

methods: {
demo01_onIndexChange (index) {
this.demo01_index = index
},
checkedBox(i) {
if(this.arr.indexOf(i)!=-1){
this.arr.splice(this.arr.indexOf(i),1);
} else {
this.arr.push(i);
}
},
gotoImg(url){
this.$router.push({path:url});
},
callPhone (phoneNum) {
window.location.href = 'tel://' + phoneNum
},
query(){
return;
var _this=this;
_this.getHotSearch();
var params={
"parameters": this.$store.state.userInfo.id,
}
_this.$doRequest('/api/doctorinfo/getWebPopularityDoctorInfo',params,res=>{
if(res.result==2){
_this.isShow=1;
_this.$router.push({path:'/physicianVisits'});
}else{
_this.isShow=0;
for(var i=0;i<res.parameters.length;i++){
res.parameters[i].style = {
'background-image': 'url('+res.parameters[i].headphoto+')'
}
if(
res.parameters[i].commentscore
){
res.parameters[i].commentscore= res.parameters[i].commentscore.toFixed(1);
}
if(res.parameters[i].skillname != null){
res.parameters[i].skillname = res.parameters[i].skillname.split(',');
}
}
_this.datalist = res.parameters;
}
})
},
gotokfc(){
this.$store.state.sun.pd = 1;
this.$router.push({path:'/myCoupon',query:{fromType: 'buy'}});
},
gotoinquiry(){
this.$router.push({path:'/inquirypeople',query:{selectType: '1'}});
},
more(){
this.$router.push({path:'/department'});
},
myDoctor(){
this.$router.push({path:'/physicianVisits'});
},
queryDoctor(){
this.displayshow = false;
this.$refs.inputs.blur();
if(this.doctorname!=''){
var searchhistory=JSON.parse(localStorage.getItem("searchhistory"))!=null?JSON.parse(localStorage.getItem("searchhistory")):[];
searchhistory.unshift(this.doctorname);
this.searchhistory=Array.from(new Set(searchhistory));
if(this.searchhistory.length>15){
this.searchhistory.splice(15,1);
}
localStorage.removeItem("searchhistory");
localStorage.setItem("searchhistory", JSON.stringify(this.searchhistory));
this.$store.state.doctorSearch=this.doctorname;
this.$router.push({path:'/doctorList'});
}
this.searchhistory=JSON.parse(localStorage.getItem("searchhistory"))?JSON.parse(localStorage.getItem("searchhistory")):[];


},
goDepartment(e){
this.$store.state.doctorSearch=e;
this.$router.push({path:'/doctorList'});
},
clearHistory(){
localStorage.removeItem("searchhistory");
this.searchhistory=[];
},
querySkill(){
this.$doRequest('/api/doctorConfirmRest/goodAtList?type=2',null,res=>{
this.skillData = res.parameters;
})
},
itemClick(id){
return
this.$store.state.AllOfValue.doctorId = id;
this.$router.push({ path: "/doctorDetails", query: { state: 'g8t7r3'} });
},
searchopen(){

this.$router.push({path:'/doctorSeek'});
this.searchhistory=JSON.parse(localStorage.getItem("searchhistory"))?JSON.parse(localStorage.getItem("searchhistory")):[];
},
getHotSearch(){
this.$doRequest('/api/hotSearch/getHotSearchList',{},res=>{
this.searchData = res.parameters;
})
},
changeClinicType(e){
if(e==1){
this.clinicType=1
this.datalist=datalist
}else{
this.clinicType=2
this.datalist=datalistCD
}
}
},

created() {
document.title = '诊所信息';
var _this=this;




}
}



// WEBPACK FOOTER //
// ./src/views/clinic/index.vue